export default function generateUserId(email) {
    if (email?.indexOf('@') === -1) {
        return email
    } else if (email) {
        return email?.split('@')[0]
    }
    return 'unknown'
}
